<template>
    <div :style="plano" id="clear-message-verification" class="flex-1">
        <login v-if="$route.name === 'Login'"></login>
        <main
            @click="closeBasketMenu"
            :style="plano"
            id="app"
            v-if="$route.name !== 'Login' && canDisplayLoadAccess"
            :class="getTheme + ' flex-1 flex-column '"
        >
            <appHeader ref="header" v-if="canDisplayLoadAccess" v-on:reset="resetSearch($event)"></appHeader>
            <div class="cf"></div>
            <div
                class="content flex-1"
                :class="[{ barAdmin: hasAccessBothAdmin() }, { withForecastBanner: getActiveAmountForecast > 0 }]"
                v-if="$route.name !== 'Plano' && $route.name !== 'Configurator'"
            >
                <div :class="'flex-1'" v-if="$route.name !== 'Login'"><router-view></router-view></div>
            </div>
            <div class="builderContainer flexContainer fd-c ai-s ac-s" :style="plano" v-if="$route.name === 'Plano'"><router-view></router-view></div>
            <div class="configWrapper flexContainer fd-r ai-s ac-s" v-if="$route.name === 'Configurator'"><router-view></router-view></div>
            <Cookie></Cookie>
            <CguModal v-if="getShown"></CguModal>
            <appFooter v-if="canDisplayLoadAccess"></appFooter>
        </main>
    </div>
</template>
<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    .content {
        padding: 0px 30px 60px;
        padding-top: 105px;
        max-width: 1920px;
        margin: 0 auto;
        width: 100%;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
            padding: 0;
        }
    }
    .builderContainer {
        padding-top: 45px;
        min-height: 640px;
    }
    .barAdmin {
        margin-top: 75px;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
            margin-top: 190px;
        }
    }
    .withForecastBanner {
        margin-top: 100px;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
            margin-top: 210px;
        }
    }
    .barAdmin.withForecastBanner {
        margin-top: 175px;
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
            margin-top: 250px;
        }
    }
    .barSandBox {
        margin-top: 100px;
    }
    .configWrapper {
        padding-top: 150px;
    }
}

@media only screen and (max-width: 767px) {
    #app {
        .content {
            padding: 0;
            margin-top: 170px;
        }
    }
}

//@media only screen and (min-width: 1200px) {
//    #app .content {
//        min-height: 88vh !important;
//    }
//}

.cadreMessage {
    border: 1px solid black;
    width: 40%;
    .errorMessage {
        color: red;
        font-size: 25px;
    }
}
</style>
<script>
import Globals from "../src/components/globals.js";
import Header from "./components/header/Header.vue";
import Footer from "./components/footer/Footer.vue";
import Breadcrumb from "./components/breadcrumb/Breadcrumb.vue";
import Login from "./components/login/Login.vue";
import { search } from "./store/catalog/search";
import { mapActions, mapGetters, mapState } from "vuex";
import messages from "../static/mocks/i18n";
import Cookie from "../src/components/login/Cookie";
import { bus } from "./main";
import CguModal from "../src/components/CguModal/CguModal";
import cacheService from "@/services/cache";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import { redirectToLoginPage } from "./services/http";

export default {
    data: () => ({
        baseUrl: Globals.getBackHost() + "/components/",
        cat: "",
        showCguModal: true,
        canDisplayLoadAccess: false,
        theme: true
    }),
    watch: {
        "$route.name"(newId, oldId) {
            if (this.$route.name === "Dashboard") {
                // location.reload()
            }
            if (this.$route.name === "Plano") {
                this.plano.height = "100%";
            } else {
                this.plano.height = null;
            }
        },
        // Regarde les changements de la var $store.state.user.disconnectingUser
        // Si elle devient true, c'est qu'il faut rediriger le user vers la page de login
        // Cette var est modifiée dans front/src/services/http.js:redirectToLogin()
        "$store.state.user.disconnectingUser"(disconnectUser) {
            if (disconnectUser) {
                this.$swal({
                    title: this.$t("changeAccess.disconnectUser.title"),
                    text: this.$t("changeAccess.disconnectUser.text"),
                    type: "warning",
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(() => {
                    // On repasse la var à false par sécurité, pour rafficher la modale
                    this.$store.state.user.disconnectingUser = false;
                    redirectToLoginPage();
                });
            }
        }
    },
    methods: {
        ...mapActions("i18n", ["setLangs", "setLocale"]),
        ...mapActions("functionality", ["findAllFunctionalities"]),
        ...mapActions("roles", ["findAllRoles"]),
        ...mapActions("forecast", { populateForecastActiveAmount: "populateActiveAmount" }),
        ...mapActions("brand", {
            populateZones: "populateZones",
            populateCampaigns: "populateCampaigns"
        }),
        ...mapActions({
            setMenuState: "basket/menu/setMenuState"
        }),
        closeBasketMenu() {
            if (this.menuIsOpened === true) {
                this.setMenuState(false);
            }
        },
        resetSearch: function(event) {},
        switchTheme() {
            this.theme = this.theme === "light" ? "dark" : "light";
        }
    },
    computed: {
        plano() {
            let defaultColor = "grey";
            let colors = this.currentBrand.brandColors || {
                color1: defaultColor,
                color2: defaultColor,
                color3: defaultColor,
                color4: defaultColor
            };

            return {
                marginTop: "0px",
                paddingTop: "0px",
                height: this.$route.name === "Plano" || this.$route.name === "Configurator" ? "100%" : undefined,
                ...Object.keys(colors).reduce((result, key) => {
                    result[`--${key}`] = colors[key];
                    return result;
                }, {})
            };
        },
        ...mapGetters({
            getAllFunctionnalitiesLight: "functionality/getAllFunctionalitiesLight",
            getRoles: "roles/getRoles",
            getAllAccess: "roles/getAllAccess",
            getBrand: "brand/getBrand",
            getTheme: "brand/getTheme",
            menuIsOpened: "basket/menu/menuIsOpened"
        }),
        ...mapGetters("cguStore", {
            getCguStatus: "getCguStatus",
            getShown: "getShown"
        }),
        ...mapGetters("currentUser", { currentUser: "currentUser" }),
        ...mapState("currentUser", ["currentBrand"]),
        ...mapGetters("forecast", { getActiveAmountForecast: "getActiveAmount" }),
        hasAccessForecasts() {
            return this.hasAccessByProfile(PROFILES.FORECAST_MANAGER) || this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR);
        },
        hasAccessForecastWindows() {
            return this.hasAccessByProfile(PROFILES.ZONE_FORECASTER) || this.hasAccessByProfile(PROFILES.ZONE_READER);
        },
        isForecastUser() {
            return this.hasAccessForecasts || this.hasAccessForecastWindows;
        }
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
        breadCrumb: Breadcrumb,
        login: Login,
        Cookie,
        CguModal
    },
    created() {
        let langues2 = [];
        bus.$on("switchTheme", event => {
            this.switchTheme();
        });
        if (cacheService.getRem3rchUser()) {
            this.$accessUser.init().then(res => {
                // do stuff after the user has been initialized
                this.canDisplayLoadAccess = res;
                if (this.isForecastUser) {
                    this.populateForecastActiveAmount({ isForecastAdmin: this.hasAccessForecasts });
                }
            });
        }
        // set a collection of langs in store i18n
        this.cat = search.actions.getResults().Promise;
        if (this.$route.name === "Plano") {
            this.plano.height = "100%";
        } else {
        }
        let langues = this.currentUser ? this.currentUser.user.languages : "";

        if (langues) {
            langues.forEach(lang => {
                langues2.push({ label: messages[lang.code].trad, value: lang.code, id: lang.id });
            });
        }
        this.setLangs(langues2);
    }
};
</script>



// WEBPACK FOOTER //
// App.vue?44fe82ed